import { render, staticRenderFns } from "./listAddonsComponent.vue?vue&type=template&id=cac0951c"
import script from "./listAddonsComponent.vue?vue&type=script&lang=js"
export * from "./listAddonsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports